import React, {PureComponent} from 'react';
import {createPortal} from 'react-dom';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {_} from 'utils/i18n';

import Modal from './Modal';

const DefaultLessonAbortModalTitle = _('Abort this lesson');

class LessonAbortModal extends PureComponent {

    constructor(props) {
        super(props);

        this.node = document.body;

        this.handleChange = this.handleChange.bind(this);

        this.state = {
            value: '',
        };
    }

    render() {
        return createPortal(<Modal {...this.props} {...this.state} onChange={this.handleChange} />, this.node);
    }

    handleChange({target}) {
        const {value} = target;

        return this.setState({value});
    }
}

LessonAbortModal.propTypes = {
    title: PropTypes.string,
};

LessonAbortModal.defaultProps = {
    title: DefaultLessonAbortModalTitle,
};

const mapStateToProps = ({abortReasons}) => ({
    abortReasons,
});

export default connect(mapStateToProps)(LessonAbortModal);



// WEBPACK FOOTER //
// ./scripts/frontend/lessons/components/LessonAbortModal/LessonAbortModal.js